
import React from 'react';
import { Typography } from '@mui/material';


export function Heading({ headingtext }) {
  return (
    <div
      style={{
        backgroundColor: "#860404ff",
        padding: "2px",
        borderRadius: "8px",
        marginBottom: "20px",
        boxShadow: "0 2px 6px rgba(112, 17, 17, 0.1)",
      }}
    >
      <Typography
        variant="h5"
        align="center"
        gutterBottom
        sx={{
          fontSize: "1rem",
          color: "white",
          fontWeight: "bold",
        }}
      >
        {headingtext}
      </Typography>
    </div>
  );
}

export function Footer({footertext }) {
  return (
    <div
      style={{
        backgroundColor: "#113be4ff",
        padding: "2px",
        borderRadius: "8px",
        marginBottom: "20px",
        boxShadow: "0 2px 6px rgba(112, 17, 17, 0.1)",
      }}
    >
      <Typography
        variant="h5"
        align="center"
        gutterBottom
        sx={{
          fontSize: "1rem",
          color: "white",
          fontWeight: "bold",
        }}
      >
        {footertext}
      </Typography>
    </div>
  );
}


export const allowedRoles = [2, 9, 999]; // roles allowed to see special cards

// export const includeCardForRoles = (roles, userRole, cardObj) => 
//   roles.includes(userRole) ? [cardObj] : [];


// export const includeCardForRoles = (rolesForCard, userRole, cardObj) =>
//   rolesForCard.includes(userRole) ? [cardObj] : [];


export const includeCardForRoles = (rolesForCard, userRole, cardObj) => {
  // 9999 has access to all cards
  if (userRole === 999 || userRole === 9) return [cardObj];
  
  return rolesForCard.includes(userRole) ? [cardObj] : [];
};

export const ROLES = {
  DOCTOR: 101,
  NURSE: 3,
  ADMIN: 5,
  STAFF: 9,
  RECEPTIONIST:999,
  ACCOUNTSECTION:5

};